import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { Calendar } from 'primereact/calendar';
import './DateRangePickerWrapper.scss';

const propTypes = {
	onDatesChange: PropTypes.func.isRequired,
	autoFocus: PropTypes.bool,
	autoFocusEndDate: PropTypes.bool,
	initialStartDate: PropTypes.string,
	initialEndDate: PropTypes.string,
	startDatePlaceholderText: PropTypes.string,
	endDatePlaceholderText: PropTypes.string,
	isOutsideRange: PropTypes.func,
	onDatePickerClick: PropTypes.func,
};

const defaultProps = {
	autoFocus: false,
	autoFocusEndDate: false,
	initialStartDate: null,
	initialEndDate: null,
	startDatePlaceholderText: 'Start Date',
	endDatePlaceholderText: 'End Date',
	isOutsideRange: () => false,
};

class DateRangePickerWrapper extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			startDate: props.initialStartDate ? new Date(props.initialStartDate) : null,
			endDate: props.initialEndDate ? new Date(props.initialEndDate) : null,
		};
	}

	formatDate = (date) => {
		return date ? format(date, 'yyyy-MM-dd') : null;
	};

	onDatesChange = ({ startDate, endDate }) => {
		this.setState({ startDate, endDate });
		this.props.onDatesChange(this.formatDate(startDate), this.formatDate(endDate));
	};

	render() {
		const { startDate, endDate } = this.state;
		const { startDatePlaceholderText, endDatePlaceholderText, onDatePickerClick } = this.props;

		return (
			<div className='row date-range-wrapper'>
				<div className='pacer-daterangepicker col-6'>
					<Calendar
						value={startDate}
						onChange={(e) => this.onDatesChange({ startDate: e.value, endDate })}
						placeholder={startDatePlaceholderText}
						disabledDates={[]} // optional if needed
						readOnlyInput
						showIcon
						onFocus={onDatePickerClick}
						dateFormat='dd M yy'
					/>
				</div>
				<div className='pacer-daterangepicker col-6'>
					<Calendar
						value={endDate}
						onChange={(e) => this.onDatesChange({ startDate, endDate: e.value })}
						placeholder={endDatePlaceholderText}
						disabledDates={[]} // optional if needed
						readOnlyInput
						showIcon
						onFocus={onDatePickerClick}
						dateFormat='dd M yy'
					/>
				</div>
			</div>
		);
	}
}

DateRangePickerWrapper.propTypes = propTypes;
DateRangePickerWrapper.defaultProps = defaultProps;

export default DateRangePickerWrapper;
